import { makeStyles } from '@mui/styles';

export const useStylesCurrentRequestedDocumentTableFolderRow = makeStyles((theme) => ({
  folder: {
    color: theme?.palette?.primary?.main,
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: ({ isSubFolder }: { isSubFolder: boolean }) => isSubFolder ? '1rem' : '0',
  },
  folderText: {
    color: theme?.palette?.primary?.main,
    fontWeight: 'bold',
  },
  icon: {
    marginRight: theme?.spacing(1),
  },
  hiddenRow: {
    display: 'none',
  },
  clickableRow: {
    cursor: 'pointer',
  },
}));
